import React from 'react';

export const CategorySpendBenchmarkContext = React.createContext({});
